import React from 'react';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import PriorityHighRoundedIcon from '@mui/icons-material/PriorityHighRounded';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

// Judul + ikon per jenis notifikasi. Warna/latar diatur di app.css (.mp-toast--*).
const VARIANTS = {
  success: { title: 'Berhasil', Icon: CheckRoundedIcon },
  error: { title: 'Gagal', Icon: PriorityHighRoundedIcon },
  warn: { title: 'Perhatian', Icon: WarningAmberRoundedIcon },
  info: { title: 'Info', Icon: InfoOutlinedIcon }
};

/** Isi notifikasi (react-toastify): ikon bergradasi, judul tebal, pesan. */
export default function ToastBody({ type = 'info', message }) {
  const { title, Icon } = VARIANTS[type] ?? VARIANTS.info;
  return (
    <div className="mp-toast-body">
      <span className="mp-toast-icon">
        <Icon fontSize="small" />
      </span>
      <span className="mp-toast-text">
        <strong>{title}</strong>
        <span>{message}</span>
      </span>
    </div>
  );
}
